<template>
  <body class="login">
    <main id="main">
      <section class="login-section">
        <Loading :isProcessing="isProcessing"></Loading>
        <div class="login-box">
          <template v-if="!isSupple">
            <h1><img src="@/assets/img/common/logo-color-set.svg" alt="労務監査クラウド ヨクスル" class="logo-set"></h1>
          </template>
          <template v-else>
            <h1><img src="@/assets/img/common/logo-roumu-color-set.svg" alt="労務監査クラウド 労務サプリ" class="logo-set"></h1>
          </template>
          <div class="login-box-input">
            <TextBox v-model.trim="$v.mailAddress.$model" placeholder="メールアドレス" name="mailAddress" />
            <ValidationErrorMessage v-show="$v.mailAddress.$error" validation="required" />
          </div>
          <div class="login-box-password">
            <Password v-model.trim="$v.password.$model" placeholder="パスワード" name="password" />
            <ValidationErrorMessage v-show="$v.password.$error" validation="required" />
          </div>
          <div class="l-btn-center">
            <div class="btn-basic is-primary">
              <button @click="login()" :disabled="isProcessing">送信</button>
            </div>
          </div>
          <ul class="login-link-list">
            <li>
              <template v-if="!isSupple">
                <router-link tag="a" id="diag" :to="{name: 'password-reset-input'}" class="link-arrow">パスワードを忘れた方はこちら</router-link>
              </template>
              <template v-else>
                <router-link tag="a" id="diag" :to="{name: 'password-reset-input', query: {supple: null}}" class="link-arrow">パスワードを忘れた方はこちら</router-link>
              </template>
            </li>
            <li>
            <!-- goTerm内で分岐させるとなぜか本番環境だけ不具合が発生したため、html側で分岐させる -->
              <a v-if="isSupple" class="link-arrow" @click="goSuppleTerm()">利用規約</a>
              <a v-else class="link-arrow" @click="goTerm()">利用規約</a>
            </li>
          </ul>
        </div>
      </section>

      <!-- OneTimePassword start -->
      <transition name="tutorialmodal-fade">
        <OnetimePasswordInput
          v-show="isShowOnetimePasswordInput"
          :userId="userId"
          @close-onetime-modal="showOnetimePasswordInput(false)"
          @onetime-password-input="emitOnetimePasswordInput"
          ref="onetimePasswordInput"
        ></OnetimePasswordInput>
      </transition>
      <!-- OneTimePassword end   -->
    </main>
  </body>
</template>

<script>
import Loading from '@/components/parts/common/Loading.vue';
import TextBox from '@/components/parts/form/TextBox.vue';
import Password from '@/components/parts/form/Password.vue';
import ValidationErrorMessage from '@/components/parts/form/ValidationErrorMessage.vue';
import { required } from 'vuelidate/lib/validators';
import OnetimePasswordInput from '@/components/parts/login/OnetimePasswordInput.vue';

export default {
  components: {
    Loading,
    TextBox,
    Password,
    ValidationErrorMessage,
    OnetimePasswordInput,
  },
  data() {
    return {
      mailAddress: '',
      password: '',
      isProcessing: false,
      isSupple: false,
      redirectUrl: '',
      isShowOnetimePasswordInput: false,
      userId: '',
      cachedMailAddress: '',
      cachedPassword: '',
    }
  },
  validations: {
    mailAddress: {
      required
    },
    password: {
      required
    }
  },
  created: function() {
    this.isSupple = Object.keys(this.$route.query).includes('supple');
    this.redirectUrl = Object.keys(this.$route.query).includes('redirect')?this.$route.query['redirect']:'';
  },
  methods: {
    async login() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.isProcessing = true;
        
        // CSRFトークン取得（確実に完了を待つ）
        try {
          await this.$axios.get('/ld/sanctum/csrf-cookie');
        } catch (csrfError) {
          console.error('CSRF token fetch error:', csrfError);
          this.$toast.error('通信エラーが発生しました。再度お試しください。');
          this.isProcessing = false;
          return;
        }

        try {
          var ret = await this.$axios.post('/ld/api/user/preLogin', { mailAddress: this.mailAddress, password: this.password });
          if ( ret == undefined ){
            this.userId = '';
            this.$toast.error('ログインに失敗しました。');
          }else if ( ret.status==200 ){
            this.userId = ret.data.userId;
            this.cachedMailAddress = this.mailAddress;
            this.cachedPassword = this.password;
            if ( ret.data.skip ){
              await this.$store.dispatch('auth/login', {
                mailAddress: this.mailAddress,
                password: this.password
              }).then((user) => {
                this.isProcessing = false;
                if (user.termsFlg) {
                  if ( this.redirectUrl ) {
                    this.$router.push({ path: this.redirectUrl });
                  }else{
                    this.$router.push({ name: 'top' });
                  }
                } else {
                  if ( this.redirectUrl ) {
                    this.$router.push({ name: 'terms',  query: { redirect: this.redirectUrl } });
                  }else{
                    this.$router.push({ name: 'terms' });
                  }
                }
              }).catch(() => {
                this.$toast.error('ユーザ名またはパスワードに誤りがあります。');
              });

            }else{
              this.showOnetimePasswordInput(true);
            }
          }else{
            this.$toast.error('ユーザ名またはパスワードに誤りがあります。');
            this.userId = '';
          }
        } catch (error) {
          // エラーハンドリング追加
          this.$toast.error('ユーザ名またはパスワードに誤りがあります。');
          this.userId = '';
          console.error('Login error:', error);
        } finally {
          this.isProcessing = false;
        }
      }
    },
    async emitOnetimePasswordInput(param){
      await this.$axios.get('/ld/sanctum/csrf-cookie')
        .catch(() => {
          return;
        });
      try{
        var ret = await this.$axios.post('/ld/api/user/checkCode', { userId: this.userId, code: param.code });
        if ( ret.status==200 && ret.data.success ){
          // 認証成功 - ログイン処理を先に実行してから画面遷移
          // preLogin時点でキャッシュした認証情報を使用（オートフィルによる上書き対策）
          await this.$store.dispatch('auth/login', {
            mailAddress: this.cachedMailAddress,
            password: this.cachedPassword
          }).then((user) => {
            this.isProcessing = false;
            // モーダルを閉じる
            this.showOnetimePasswordInput(false);
            // ページ遷移
            if (user.termsFlg) {
              if ( this.redirectUrl ) {
                this.$router.push({ path: this.redirectUrl });
              }else{
                this.$router.push({ name: 'top' });
              }
            } else {
              if ( this.redirectUrl ) {
                this.$router.push({ name: 'terms',  query: { redirect: this.redirectUrl } });
              }else{
                this.$router.push({ name: 'terms' });
              }
            }
          }).catch(() => {
            this.showOnetimePasswordInput(false);
            this.$toast.error('ユーザ名またはパスワードに誤りがあります。');
          });
        }else if ( ret.status==200 && ret.data.success === false ){
          // 認証失敗 - エラーメッセージを画面上に表示（モーダルは開いたまま）
          const errorMessage = ret.data.message || '認証コードが正しくないか、有効期限切れです。';
          if (this.$refs.onetimePasswordInput) {
            this.$refs.onetimePasswordInput.showError(errorMessage);
          }
        }
      }catch(e){
        // 通信エラーなど予期しないエラー
        const errorMessage = '通信エラーが発生しました。再度お試しください。';
        if (this.$refs.onetimePasswordInput) {
          this.$refs.onetimePasswordInput.showError(errorMessage);
        }
      }
    },
    goTerm() {
      this.$router.push({ name: 'terms' });
    },
    goSuppleTerm() {
      this.$router.push({ name: 'terms', query: {supple: null} });
    },
    showOnetimePasswordInput(value) {
      if ( value ){
        const inputs = document.querySelectorAll('.box-passcode-input');
        inputs.forEach((input, index) => {
          input.addEventListener('input', () => {
            if (input.value.length === 1 && index < inputs.length - 1) {
              inputs[index + 1].focus();
            }
          });
          input.addEventListener('keydown', (e) => {
            if (e.key === 'Backspace' && input.value.length === 0 && index > 0) {
              inputs[index - 1].focus();
            }
          });
        });
      }else{
        this.userId = '';
        this.cachedMailAddress = '';
        this.cachedPassword = '';
        const inputs = document.querySelectorAll('.box-passcode-input');
        inputs.forEach((input) => {
          input.value = '';
        });

      }
      this.isShowOnetimePasswordInput = value;
    },
  }
}
</script>
